import Modal from "react-bootstrap/Modal";
import React, { useState, useEffect } from "react";
import axios from "axios";
import "../../Style/Checkbox.scss";
import "../../Style/__button.scss";
import "../../Style/InsertModal.scss";
import { errorAlert, handleSuccess } from "../../Components/Alerts";
import { ApiLink } from "../../APILink/ApiLink";
import authHeader from "../../Auth/authHeader";
import LoginUserDetailed from "../../Auth/LoginUserDetailed";
import TextField from "@mui/material/TextField";
import { TextareaAutosize } from "@mui/material";
import { Button } from "@mui/material";
import AddBoxIcon from "@mui/icons-material/AddBox";
import { AddElementsButton } from "../../Components/AddElementsButton";
import Autocomplete from "@mui/material/Autocomplete";
import { getCompanyUnits } from "../../GetData/CompanyUnitsData";

function InsertFiscalCashRegister(props) {
  const [hash, setHash] = useState("");
  const [companyID, setCompanyID] = useState();
  const [posID, setPosID] = useState();
  const [location, setLocation] = useState("");
  const [description, setDescription] = useState("");
  const [isActive, setIsActive] = useState(true);
  const [unitID, setUnitID] = useState(0);

  const [company, setCompany] = useState([]);
  const [paymentsAccounts, setPaymentsAccounts] = useState([]);
  const [companyUnits, setCompanyUnits] = useState([]);

  const email = LoginUserDetailed(); // ndryshoni me emailin e përdoruesit të kyqur
  const headers = authHeader();

  const handleSubmit = (event) => {
    event.preventDefault();
    const stateData = {
      CashRegisterHash: hash,
      POSID: posID,
      CompanyID: companyID,
      LocationName: location,
      Description: description,
      CreatedByUser: email,
      IsActive: isActive,
      UnitID:unitID
    };
    axios
      .post(ApiLink.API_URL + "FiscalCashRegister", stateData, { headers })
      .then((response) => {
        // console.log(response.data);
        handleSuccess("P.O.S-i u insertua me sukses");
        setHash("");
        setPosID();
        setCompanyID();
        setLocation("");
        setDescription("");
        setIsActive(true);
        setUnitID(0);
        props.onHide();
        props.refreshData(); // Thirrja e funksionit per refresh te dhenave
      })
      .catch((error) => {
        // console.error(error);
        if (error.response && error.response.status === 409) {
          errorAlert(error.response.data);
          handleClose();
        } else {
          errorAlert("An unknown error occurred while processing the request.");
        }
      });
  };

  const handleClose = () => {
    // Ky funksion do të përdoret për të mbyllur modalin
    props.onHide();
    setHash("");
    setPosID();
    setCompanyID();
    setLocation("");
    setDescription("");
    setIsActive(true);
  };

  useEffect(() => {
    axios
      .get(ApiLink.API_URL + "companies", { headers })
      .then((response) => {
        setCompany(response.data);
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);

  // const fetchPaymentsAccount = async (id) => {
  //     try {
  //         const response = await axios.get(ApiLink.API_URL + 'Accounts/accountByLedgerandCompany', { headers, params: { ledger: 101, id: id } });
  //         setPaymentsAccounts(response.data);
  //     } catch (error) {
  //         errorAlert("Gabim në kërkesë:", error);

  //         if (error.response && error.response.data && error.response.data.errorMessage) {
  //             errorAlert(`Gabim në marrjen e të dhënave: ${error.response.data.errorMessage}`);
  //         } else if (error.message) {
  //             errorAlert(`Gabim: ${error.message}`);
  //         } else {
  //             errorAlert("Gabim i panjohur në kërkesë. Shih konsolën për detaje.");
  //         }
  //     }
  // };

  const fetchPaymentsAccount = async (id) => {
    try {
      // Thirrja e parë (Accounts)
      const response = await axios.get(
        ApiLink.API_URL + "Accounts/accountByLedgerandCompany",
        {
          headers,
          params: { ledger: 101, id: id },
        },
      );
      setPaymentsAccounts(response.data);

      //marrja e njesive organizative
      const units = await getCompanyUnits(id);
      setCompanyUnits(units); 
    } catch (error) {
      // Logjika jote ekzistuese për error alert
      errorAlert("Gabim në kërkesë:", error);
      if (
        error.response &&
        error.response.data &&
        error.response.data.errorMessage
      ) {
        errorAlert(
          `Gabim në marrjen e të dhënave: ${error.response.data.errorMessage}`,
        );
      } else if (error.message) {
        errorAlert(`Gabim: ${error.message}`);
      } else {
        errorAlert("Gabim i panjohur.");
      }
    }
  };

  //Per ta zgjedhur kompanin
  const handleAutocompleteChangeCompany = (event, value) => {
    if (value) {
      setCompanyID(value.CompanyID);
      fetchPaymentsAccount(value.CompanyID);
    } else {
      setCompanyID();
    }
  };

  const defaultPropsCompany = {
    options: company,
    getOptionLabel: (option) => option.CompanyName || "",
  };

  const handleAutocompletePaymentOptions = (event, value) => {
    if (value) {
      setPosID(value.AccountID);
    } else {
      setPosID();
    }
  };

  const defaultPropsPaymentOptions = {
    options: paymentsAccounts,
    getOptionLabel: (option) => option.AccountName || "",
  };

  //Per ta zgjedhur njesin e kompanis
  const handleAutocompleteChangeCompanyUnit = (event, value) => {
    if (value) {
      setUnitID(value.UnitID);
    } else {
      setUnitID("");
    }
  };

  const defaultPropsCompanyUnit = {
    options: companyUnits,
    getOptionLabel: (option) => option.UnitName || "",
  };

  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header style={{ backgroundColor: "#284945" }}>
        <Modal.Title id="contained-modal-title-vcenter">
          Krijo P.O.S. të ri
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <form onSubmit={handleSubmit} className="InsertModal__Container__Form">
          <div className="InsertModal__Container__Form__Container2">
            <div style={{ width: "100%" }}>
              <TextField
                style={{ width: "100%" }}
                id="HashCode"
                label="Hash Code"
                variant="outlined"
                type="text"
                name="HashCode"
                autoComplete="off"
                required
                value={hash}
                onChange={(event) => {
                  setHash(event.target.value);
                }}
              />
            </div>
            <div className="InsertModal__Container__Form__Container2__selects">
              <div className="InsertModal__Container__Form__Container2__selects__textfield_button">
                <Autocomplete
                  fullWidth
                  sx={{ m: 1 }}
                  {...defaultPropsCompany}
                  id="include-input-in-list"
                  includeInputInList
                  required
                  onChange={handleAutocompleteChangeCompany} // Shto funksionin onChange
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Zgjedh Kompanin"
                      variant="standard"
                      required
                    />
                  )}
                />
              </div>
              <div className="InsertModal__Container__Form__Container2__selects__textfield_button">
                <Autocomplete
                  fullWidth
                  sx={{ m: 1 }}
                  {...defaultPropsPaymentOptions}
                  id="include-input-in-list"
                  includeInputInList
                  required
                  onChange={handleAutocompletePaymentOptions} // Shto funksionin onChange
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Zgjedh arken"
                      variant="standard"
                      required
                    />
                  )}
                />
              </div>
            </div>
            <Autocomplete
              fullWidth
              sx={{ m: 1 }}
              {...defaultPropsCompanyUnit}
              id="include-input-in-list"
              includeInputInList
              onChange={handleAutocompleteChangeCompanyUnit} // Shto funksionin onChange
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Zgjedh Njesin"
                  variant="standard"
                />
              )}
            />
            <div style={{ width: "100%" }}>
              <TextField
                style={{ width: "100%" }}
                id="LocationName"
                label="Lokacioni P.O.S-it"
                variant="outlined"
                type="text"
                name="LocationName"
                autoComplete="off"
                value={location}
                onChange={(event) => {
                  setLocation(event.target.value);
                }}
              />
            </div>
            <br></br>
            <div className="InsertModal__Container__Form__Container2__field__description">
              <TextareaAutosize
                style={{ height: "100px" }}
                className="InsertModal__Container__Form__Container2__field__descriptionArea"
                id="Description"
                label="Përshkrimi"
                variant="outlined"
                placeholder="Përshkrimi"
                type="text"
                autoComplete="off"
                name="Description"
                value={description}
                onChange={(event) => setDescription(event.target.value)}
              />
            </div>
            <div className="InsertModal__Container__Form__Container2__buttons">
              <div>
                <label className="InsertModal__Container__Form__Container2__checkbox-label">
                  <input
                    type="checkbox"
                    checked={isActive}
                    onChange={(event) => setIsActive(event.target.checked)}
                    className="InsertModal__Container__Form__Container2__checkbox-input"
                  />
                  <span className="InsertModal__Container__Form__Container2__checkbox-custom"></span>
                  Active
                </label>
              </div>
              <div className="InsertModal__Container__Form__Container2__save-button">
                <button
                  type="submit"
                  className="btn btn-success float-end"
                  style={{ width: "120px" }}
                >
                  Ruaj & Mbyll
                </button>
              </div>
              <Button variant="secondary" onClick={handleClose}>
                Mbyll
              </Button>
            </div>
          </div>
        </form>
      </Modal.Body>
    </Modal>
  );
}

export default function InsertData(props) {
  const [modalShow, setModalShow] = React.useState(false);

  const handleRefreshData = () => {
    props.fetchData(); // Thirrja e funksionit per refresh te dhenave
  };
  return (
    <div>
      {props.type === "text" ? (
        <AddElementsButton
          text="Krijo P.O.S"
          onClick={() => setModalShow(true)}
          icon="bi bi-upc-scan"
          className="button-68"
        />
      ) : props.type === "insert" ? (
        <AddElementsButton
          text="Krijo P.O.S"
          onClick={() => setModalShow(true)}
          icon="bi bi-upc-scan"
          className="button-15"
        />
      ) : props.type === "menu" ? (
        <i class="bi bi-upc-scan" onClick={() => setModalShow(true)}></i>
      ) : (
        <AddBoxIcon
          style={{ height: "29px", color: "black" }}
          onClick={() => setModalShow(true)}
        />
      )}
      <InsertFiscalCashRegister
        show={modalShow}
        onHide={() => setModalShow(false)}
        refreshData={handleRefreshData}
      />
    </div>
  );
}
